// extracted by mini-css-extract-plugin
export default {"modalOverlay":"rC-z","modalContent":"sC-z","header":"tC-z","close":"uC-z"};